"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledContainer = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const config_1 = require("../../../assets/styles/config");
exports.StyledContainer = styled_components_1.default.div `
  align-items: center;
  background: white;
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  height: 90%;
  justify-content: center;
  min-height: 415px;
  width: 90%;

  @media ${config_1.device.mobileLarge} {
    height: 96%;
  }

  @media ${config_1.device.laptop} {
    min-height: 800px;
    width: 40%;
    height: 65%;
  }

  @media ${config_1.device.laptopLarge} {
    height: 100%;
  }
`;
